import clsx from "clsx";
import { Controller, useFormState } from "react-hook-form";
import Select from "react-select";
import { REQ_ERR_MSG } from "../../Shared/Helper/ValidationMessage";
import { components } from "react-select";
import { LookupInterface } from "../../Pages/CompanyAccount/model/accountForm.model";

interface fSProps {
  name: string;
  control: any;
  optionList: LookupInterface[] | any[] | undefined;
  placeholder?: any;
  className?: string;
  errors?: any;
  required?: boolean;
  isSearchable?: boolean;
  isClearable?: boolean;
  tabIndex?: number;
  defaultValue?: any;
  autofocus?: boolean;
  onChange?: (selected: any) => any;
  label?: string;
  menuIsOpen?: boolean;
  classNamePrefix?: string;
  hidden?: boolean;
  selectedOption?: (selected: any) => any;
  disabled?: boolean;
}

export default function FormSelect(props: fSProps) {
  const {
    control,
    optionList,
    placeholder,
    name,
    errors,
    hidden,
    required = false,
    isSearchable = false,
    isClearable = false,
    tabIndex,
    defaultValue,
    autofocus = false,
    label,
    onChange,
    menuIsOpen,
    classNamePrefix,
    selectedOption,
    disabled,
  } = props;
  // Get form state to check if the form has been submitted
  const { isSubmitted } = useFormState({ control });

  // Function to check if the field is required and has no value
  const isFieldInvalid = (value: any) => {
    return required && isSubmitted && !value; // Only invalid if the form is submitted and the field is empty
  };

  // Dynamically apply the red border class if the field is invalid
  const inputClassName = clsx("border-none control-search", props.className, {
    "border-danger": isFieldInvalid(defaultValue), // Add red border if the field is invalid
  });

  const CustomMenuList = (props: any) => {
    return (
      <components.MenuList {...props}>
        {label && (
          <div className="dropdown-label">
            <strong className="ps-1">{label}</strong>
          </div>
        )}
        {props.children}
      </components.MenuList>
    );
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || null}
        rules={{
          ...(required && { required: { value: true, message: REQ_ERR_MSG } }),
        }}
        render={({ field: { onChange, value } }) => {
          const isInvalid = isFieldInvalid(value);

          // Filter out any undefined or invalid options
          const validOptions =
            optionList?.filter(
              (option) =>
                option &&
                typeof option === "object" &&
                "label" in option &&
                "value" in option
            ) || [];

          return (
            <>
              <Select
                autoFocus={autofocus}
                tabIndex={tabIndex}
                options={validOptions}
                placeholder={placeholder}
                value={
                  validOptions.find((option) => option?.value === value) || null
                }
                className={`${inputClassName} ${hidden && "d-none"}`}
                classNamePrefix={classNamePrefix ?? "ss"}
                defaultValue={defaultValue}
                isSearchable={isSearchable}
                isClearable={isClearable}
                isDisabled={disabled} 
                onChange={(itm) => {
                  onChange(itm.value ?? "");
                  if (selectedOption) {
                    selectedOption(itm);
                  }
                }}
                components={label ? { MenuList: CustomMenuList } : undefined}
                menuIsOpen={menuIsOpen}
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    border: isInvalid ? "1px solid red" : provided.border,
                  }),
                }}
              />
              {isInvalid && (
                <div>
                  <span className="text-danger">{REQ_ERR_MSG}</span>
                </div>
              )}
            </>
          );
        }}
      />
    </>
  );
}
